
import { ApiService }               from '../api/api.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { GsfSettingsComponent }     from './gsf.settings.component';
import { SessionService }        from '../sessions/session.service';

export const GsfStates : Array<any> = [
  {
    component: GsfSettingsComponent,
    name     : 'app.gsf-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<CompanyIntegrationsModel> => apiService.get('/company_integrations'),
        token    : 'settings'
      }
    ],
    url: '/gsf-settings'
  }
];